import $ from 'cash-dom';
import { matchLg } from '../media';

export class ServicesModule {

    static name = 'services';

    constructor(node) {

        this.node = node;

        document.fonts.ready.then(() => this.handleResize());
        $(window).on('resize', this.handleResize);
        $(document).on('focus', this.handleResize);

        $(node).find('.services-item-title').on('click', function() {
            
            const item = $(this).parents('.services-item').first();
            const group = $(this).parents('.services-group').first();
            const content = item.find('.services-item-content').first();

            if(item.hasClass('open')) {
                close(item);
            } else {
                item.data('closedHeight', item.outerHeight());
                open();
            }

            function open() {
                const groupHeight = group.outerHeight();
                const closedHeight = item.data('closedHeight');

                // prepare animation
                item.css('height', `${closedHeight}px`); // prime item height for animation
                content.css('display', 'block'); // make content visible so we can measure height
                
                // read height 
                item[0].getBoundingClientRect(); // trigger reflow
                const actualHeight = closedHeight + content.outerHeight();
                const targetHeight = matchLg.matches ? Math.max(groupHeight, actualHeight) : actualHeight;
                content.css('opacity', 1);

                // fire animations
                item
                    .addClass('open')
                    .css('height', `${targetHeight}px`)

                // additional desktop stuff
                if(matchLg.matches) {
                    group.css('height', `${targetHeight}px`);

                    // offset prevAll
                    let combinedHeight = 0;
                    item.prevAll('.services-item').each(function() {
                        combinedHeight += $(this).outerHeight();
                    })
                    .last()
                    .addClass('offset').css('margin-top', `-${combinedHeight}px`);

                    group[0].scrollIntoView({ behavior: "smooth" });
                } else {
                    item[0].scrollIntoView({ behavior: "smooth" });
                }
            }
    
            function close() {

                // fade-out content
                content.css('opacity', 0);

                // reset offset prevAll
                item.prevAll('.services-item.offset')
                .css('margin-top', `0`);

                // reset item height
                const closedHeight = item.data('closedHeight');
                item.on('transitionend', handleCloseEnd);
                item.css('height', `${closedHeight}px`);

            }

            function handleCloseEnd(e) {

                if(e.target !== item[0]) return;
                item.off('transitionend', handleCloseEnd);

                content.css('display', 'none');
                item.removeClass('open');

                // reset group
                group.removeClass('open').removeAttr('style');
            }
        });
    }

    handleResize = () => {

        if(matchLg.matches) {

            // reset everything
            $(this.node).find('[style]').removeAttr('style');
            $(this.node).find('.open').removeClass('open');

            // set left/right to equal heights
            // need a timeout here to make sure the style has been removed
            window.clearTimeout(this.heightTimeout);
            this.heightTimeout = window.setTimeout(() => {
                const groups = $(this.node).find('.services-group');
                const maxItems = Math.max( ... groups.map((i, el) => $(el).find('.services-item').length).get());
                
                for(let i=0; i<maxItems; i++) {
                    const items = groups.map((_, el) => $(el).find('.services-item').eq(i).get());
                    const maxHeight = Math.max( ... items.map((i, el) => $(el).outerHeight()));
                    items.css('height', `${maxHeight}px`);
                }
            }, 100);
        }
    }
}